import { useEffect, useState } from 'react';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import { 
    ENTITY_TYPES,
    BROKER_SORT_BY_TYPES,
    ASSISTER_SORT_BY_TYPES
}  from '../constants/crm/screenpopTypes';


const useBrokerAssisterTableData = (props) => {

    const {
        entityType,
        sortByHandler,
        sortBy
    } = props;


    const [ columns, setColumns ] = useState([]);

    const brokerColumns = [
        {
            id: 'agentName',
            isLink: true,
            isSortable: true,   
            text: 'screenpop.table.header.agentName',
            type: 'link',
            sortableHandler: () => sortByHandler(BROKER_SORT_BY_TYPES.CONTACT_NAME, sortBy)
        },
        {
            id: 'role',
            type: 'link',
            text: 'screenpop.table.header.role'
        },
        {
            id: 'companyName',
            isSortable: true,
            text: 'screenpop.table.header.businessName',
            type: 'link',
            sortableHandler: () => sortByHandler(BROKER_SORT_BY_TYPES.COMPANY_NAME, sortBy)
        },
        {
            id: 'licenseNumber',
            isSortable: true,
            text: 'screenpop.table.header.licenseNumber',
            type: 'link',
            sortableHandler: () => sortByHandler(BROKER_SORT_BY_TYPES.LICENSE_NUMBER, sortBy)
        },
        {
            id: 'certificationStatus',
            isSortable: true,
            text: 'screenpop.table.header.certificationStatus',
            type: 'link',
            sortableHandler: () => sortByHandler(BROKER_SORT_BY_TYPES.CERTIFICATION_STATUS, sortBy)
        },
        {
            id: 'edit',
            type: 'icon',
            text: 'Edit',
            isIcon: true,
            icon: faCog,
            actions: [ 'Edit' ]
        }
    ];

    const assisterColumns = [
        {
            id: 'name',
            isLink: true,
            isSortable: true,
            text: 'screenpop.table.header.name',
            type: 'link',
            sortableHandler: () => sortByHandler(ASSISTER_SORT_BY_TYPES.CONTACT_NAME, sortBy)
        },
        {
            id: 'entityName',
            isLink: true,
            isSortable: true,
            text: 'screenpop.table.header.entityName',
            type: 'link',
            sortableHandler: () => sortByHandler(ASSISTER_SORT_BY_TYPES.ENTITY_NAME, sortBy)
        },
        {
            id: 'renewalDate',
            isSortable: true,
            text: 'screenpop.table.header.renewalDate',
            type: 'link',
            sortableHandler: () => sortByHandler(ASSISTER_SORT_BY_TYPES.RECERTIFICATION_DATE, sortBy)
        },
        {
            id: 'status',
            isSortable: true,
            text: 'screenpop.table.header.status',
            type: 'link',
            sortableHandler: () => sortByHandler(ASSISTER_SORT_BY_TYPES.STATUS, sortBy)
        },
        {
            id: 'certificationStatus',
            isSortable: true,
            text: 'screenpop.table.header.certificationStatus',
            type: 'link',
            sortableHandler: () => sortByHandler(ASSISTER_SORT_BY_TYPES.CERTIFICATION_STATUS, sortBy)
        },
        {
            id: 'gear',
            type: 'icon',
            isIcon: true,
            icon: faCog,
            actions: [ 'Edit' ]
        }
    ];

    useEffect(() => {
        switch(entityType) {
            case ENTITY_TYPES.BROKER:
                setColumns(brokerColumns);
                break;
            case ENTITY_TYPES.ASSISTER:
                setColumns(assisterColumns);
                break;
        }
    }, [ entityType, sortBy ]);



    return {
        columns
    };
};

export default useBrokerAssisterTableData;